import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";
import { navItems } from "../data/navigation";
export function ComingSoon() {
  const {
    pathname
  } = useLocation();
  const all = navItems.flatMap(i => [{
    label: i.label,
    href: i.href
  }, ...(i.children ?? [])]);
  const title = all.find(i => i.href === pathname)?.label ?? "Page en préparation";
  return <section className="bg-paper px-5 pb-28 pt-40 md:px-8" data-id="element-196" data-mp="da72k39xcwzj">
      <div className="mx-auto max-w-2xl text-center" data-id="element-197" data-mp="99n3uv9pdlba">
        <h1 className="font-display text-5xl font-medium tracking-tight text-ink md:text-6xl" data-id="element-198" data-mp="995b48m91p84">{title}</h1>
        <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-199" data-mp="n0jrs8sopec0">
          Cette page fait partie de la nouvelle architecture du site. Pour la démonstration, seule la page d'accueil est développée.
        </p>
        <Link to="/" className="mt-10 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-forest" data-id="element-200" data-mp="wzhjtlpbjpzr">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-201" data-mp="x8cpzjysfkeg" />
          Retour à l'accueil
        </Link>
      </div>
    </section>;
}